import { defineStore } from 'pinia';
import type { Company, Brand } from '@Shared';
import { getCompanyInfoFromSessionApi } from '@Api/company.api';

export const useCompanyStore = defineStore('company', {
    state: () => ({
        company: null as Company | null,
        brand: null as Brand | null,
        companySlug: null as string | null,
    }),
    actions: {
        setCompany(newCompany: Company) {
            this.company = newCompany;
        },
        setBrand(newBrand: Brand | null) {
            this.brand = newBrand;
        },
        // The host fills company.phoneNumber from an endpoint that needs an OTP-passed activity
        // session. The dashboard can run on its access token with a bare session (e.g. after the
        // session TTL), so fall back to dashboard-bff, which accepts the token, when it is missing.
        async loadCompanyPhone() {
            const companyId = this.company?.id;
            if (!companyId || this.company?.phoneNumber) return;

            try {
                const companyInfo = await getCompanyInfoFromSessionApi();
                if (!companyInfo?.phone || companyInfo.id !== companyId || this.company?.id !== companyId) return;

                this.company = { ...this.company, phoneNumber: companyInfo.phone };
            } catch {
                // Best-effort: without a phone the sidebar simply hides the call option.
            }
        },
    },
});
